// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.BMap_noprint {\n    z-index: 99 !important;\n}\n#cap,\n#join,\n.captext,\n.jointext {\n    position: absolute;\n    z-index: 0;\n    top: 20px;\n    left: 40px;\n    width: 100px;\n    font-size: 16px;\n}\n", ""]);
// Exports
module.exports = exports;
